import * as React from 'react'

import {
  useCustomer,
  useFormattableI18nProperty,
  useSiteConfig,
} from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { LoyaltyPoints } from '@thg-commerce/gravity-patterns'
import { spacing, styled } from '@thg-commerce/gravity-theme'

import { useProductPage } from '../../context/ProductPageContext'

const StyledLoyaltyPoints = styled(LoyaltyPoints)`
  margin-top: ${spacing(1)};
`

export const LoyaltyPointsMessage = () => {
  const { selectedVariant } = useProductPage()
  const customer = useCustomer()
  const { showLoyaltyPointsToNextTier } = useSiteConfig()
  const theme = useTheme()

  const i18nText = {
    loyaltyPointsText: useFormattableI18nProperty(
      'product.loyalty.points.text',
    ),
    loyaltyPointsToNextTierText: useFormattableI18nProperty(
      'product.loyalty.pointstonexttier',
    ),
  }

  if (!selectedVariant?.earnableLoyaltyPoints) {
    return null
  }

  const pointsToNextTier =
    showLoyaltyPointsToNextTier && customer?.loyalty?.pointsToNextTier

  const loyaltyPointsText = `${i18nText.loyaltyPointsText(
    selectedVariant.earnableLoyaltyPoints.toString(),
  )}${
    (pointsToNextTier &&
      `. ${i18nText.loyaltyPointsToNextTierText(
        pointsToNextTier.toString(),
      )}`) ||
    ''
  }`

  return (
    <React.Fragment>
      <StyledLoyaltyPoints
        pointsText={loyaltyPointsText}
        iconTheme={theme.pageTheme.productSummary.loyaltyPointsIcon}
      />
    </React.Fragment>
  )
}
